/* eslint-disable no-param-reassign */
/* eslint-disable prefer-template */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef, useState } from 'react';
import MaterialTable, { MTableFilterRow } from 'material-table';
import { TablePagination } from '@material-ui/core';
import { Overlay } from 'react-bootstrap';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
// import { CsvBuilder } from 'filefy';
import XLSX from 'xlsx';
import { BotaoContainer, Container, ModalContainer } from './styles';
import cores from '../../styles/cores';
import Filter from '../../assets/Icons/FilterIcon';
import Modal from '../Modal/Modal';
import Botao from '../Botao/Botao';


interface IGridProps {
  columns: any;
  data: any;
  pagination?: any;
  paginationPageSize?: any;
  title: any;
  haveActions?: string;
  onRowClick(e: any, rowData: any): any;
  editarClick(event: any, data: any): any;
  excluirClick(event: any, data: any): any;
  updateCellCallbackFunction?(newValue: any, oldValue: any, rowData: any): any;
  isLoading?: boolean;
  count?: any;
  rowPerPage?: any;
  currentPage?: any;
  totalCount?: any;
  setCurrentPage?: any;
}

const PaginatedTable = (props: IGridProps) => {
  const {
    columns,
    data,
    onRowClick,
    updateCellCallbackFunction,
    pagination,
    paginationPageSize,
    title,
    haveActions,
    isLoading,
    count = 1,
    rowPerPage = 10,
    currentPage,
    totalCount,
    setCurrentPage,
  } = props;


  

  let { editarClick, excluirClick } = props;

  editarClick = editarClick || undefined;
  excluirClick = excluirClick || undefined;

  let myActions;

  if (haveActions === 'none') {
    myActions = undefined;
  }
  if (haveActions === 'edit') {
    myActions = [
      {
        icon: () => {
          return <EditIcon style={{ fontSize: 32 }} className="editar" />;
        },
        tooltip: 'Editar',
        onClick: editarClick,
      },
    ];
  }
  if (haveActions === 'editdelete') {
    myActions = [
      {
        icon: () => {
          return <EditIcon style={{ fontSize: 32 }} className="editar" />;
        },
        tooltip: 'Editar',
        onClick: editarClick,
      },
      // {
      //   icon: () => {
      //     return <DeleteIcon style={{ fontSize: 32 }} className="excluir" />;
      //   },
      //   tooltip: 'Excluir',
      //   onClick: excluirClick,
      // },
    ];
  }

  const modifiedColumns = columns.map((column: { editable: string; }) => {
    if (column.editable && column.editable !== '') {
      return column
    }
    column.editable = 'never'
    return column
  })

  return (
    <Container>
      <MaterialTable
        title={title}
        data={data}
        isLoading={isLoading}
        columns={modifiedColumns}
        cellEditable={{
          onCellEditApproved: (newValue, oldValue, rowData, columnDef) => {
            return new Promise((resolve, reject) => {
              if (updateCellCallbackFunction) {
                updateCellCallbackFunction(newValue, oldValue, rowData);
              }
              setTimeout(resolve, 1000);
            });
          }
        }}

        components={{
          Pagination: props => (
            <TablePagination
              {...props}
              count={totalCount}
              rowsPerPage={rowPerPage}
              rowsPerPageOptions={[rowPerPage]}
              page={currentPage - 1}
              onChangePage={(event, page: any) => {
                setCurrentPage(page + 1);
              }}
            />
          )
        }}
        options={{
          pageSize: rowPerPage,
          hideFilterIcons: false,
          thirdSortClick: false,
          search: false,
          paging: true,
          filtering: false,
          exportButton: true,
          exportAllData: true,
          headerStyle: {
            fontSize: 16,
            fontWeight: 'bold',
          },
          loadingType: "linear",
          actionsColumnIndex: 99,
          exportDelimiter: ',',
          exportCsv: (columnsExport, dataExport) => {

            const notExportableColumns: Array<string> = [];

            for (let i = 0; i < columnsExport.length; i++) {
              if (columnsExport[i].export === false) {
                notExportableColumns.push(columnsExport[i].field);
              }
            }

            const newData = dataExport.map((row: any) => {
              delete row.tableData;
              for (let i = 0; i < notExportableColumns.length; i++) {
                // eslint-disable-next-line dot-notation
                delete row[notExportableColumns[i]];
              }
              return row;
            });

            const workSheet = XLSX.utils.json_to_sheet(newData);
            const workBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(
              workBook,
              workSheet,
              `${title.trim()}`,
            );
            // Buffer
            const buf = XLSX.write(workBook, {
              bookType: 'xlsx',
              type: 'buffer',
            });
            // Binary string
            XLSX.write(workBook, { bookType: 'xlsx', type: 'binary' });
            // Download
            XLSX.writeFile(workBook, `${title.trim()}.xlsx`);
          },
        }}
        onRowClick={onRowClick}
        actions={myActions}
        localization={{
          body: {
            emptyDataSourceMessage: `${isLoading ? 'Carregando...' : 'Nenhum dado para exibir'}`,
          },
          toolbar: {
            searchTooltip: 'Pesquisar',
            searchPlaceholder: 'Pesquisar',
            exportCSVName: 'Exportar como Excel',
            exportPDFName: 'Exportar como PDF',
          },
          header: {
            actions: 'Ações'
          },
          pagination: {
            labelDisplayedRows: '{count} de {from}-{to}',
            firstTooltip: 'Primeira página',
            previousTooltip: 'Página anterior',
            nextTooltip: 'Próxima página',
            lastTooltip: 'Última página',
          },
        }}
      />
    </Container>
  );
};

PaginatedTable.defaultProps = {
  haveActions: 'editdelete',
  isLoading: false
};

export default PaginatedTable;
